var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.switchMode
      ? _c("h2", [_vm._v("Supsis-Instagram Integration Purchase")])
      : _vm._e(),
    _vm._v(" "),
    !_vm.switchMode
      ? _c("span", [
          _vm._v(
            "\n        Instagram Feature billed month-to-month. Your instagram service will be activated after you accept\n        subscription."
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.switchMode ? _c("h2", [_vm._v("Instagram Plans")]) : _vm._e(),
    _vm._v(" "),
    _vm.switchMode
      ? _c("span", [_vm._v(_vm._s(_vm.$t("wp.selectBestPlan")))])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "plans mt-5" },
      [
        _c("InstagramBasicPlanCard", {
          attrs: {
            selected: _vm.instagramBasicEnabled,
            "on-selected": function () {
              return _vm.onPlanSelected("instagram-basic")
            },
          },
        }),
        _vm._v(" "),
        _c("InstagramPlusPlanCard", {
          attrs: {
            selected: _vm.instagramPlusEnabled,
            "on-selected": function () {
              return _vm.onPlanSelected("instagram-plus")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }